var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 62,
    viewBox: "0 0 66 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9585 42.9274C18.9327 41.7382 16.3264 42.4163 15.1371 44.4421C13.9479 46.4679 14.626 49.0742 16.6518 50.2634C18.6776 51.4527 21.2839 50.7745 22.4732 48.7487C23.6624 46.723 22.9843 44.1167 20.9585 42.9274Z",
    fill: "#3897FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2019 23.774L58.6206 31.1497L64.2002 35.9917L56.8245 36.4105L51.9824 41.99L51.5633 34.6145L45.9841 29.7722L53.3598 29.3535L58.2019 23.774Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8747 10.7738L30.2884 16.6979L37.6123 17.6645L31.6879 22.0782L30.7217 29.4021L26.308 23.4781L18.9841 22.5114L24.9079 18.0979L25.8747 10.7738Z",
    fill: "#8E4DD5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.94dda51ae1137babfa3bc05da92347f5.svg";
export { ForwardRef as ReactComponent };